import { connect } from 'react-redux';
import NotificationPage from '../components/notification_page/NotificationPageComponent.js';
import actions from '../redux/actions/notification';

const mapStateToProps = (state) => ({
  listNotifications: state.notification.listNotifications,
  userNotifications: state.notification.userNotifications,
  markedNotifications: state.notification.markedNotifications,
});

const mapDispatchToProps = (dispatch) => ({
  fetchNotifications: (params, callback) => {
    dispatch(actions.fetchNotifications(params, callback));
  },
  fetchUserNotifications: (params, callback) => {
    dispatch(actions.fetchUserNotifications(params, callback));
  },
  fetchMarkedNotifications: (params, callback) => {
    dispatch(actions.fetchMarkedNotifications(params, callback));
  },
  checkedUserNotifications: (params, callback) => {
    dispatch(actions.checkedUserNotifications(params, callback));
  },
  checkedAllUserNotifications: (params, callback) => {
    dispatch(actions.checkedAllUserNotifications(params, callback));
  },
  deleteUserNotifications: (params, callback) => {
    dispatch(actions.deleteUserNotifications(params, callback));
  },
  deleteAllUserNotifications: (params, callback) => {
    dispatch(actions.deleteAllUserNotifications(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPage);
